/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { ConfigState, ConfigActionTypes } from './types';

export const initialState: ConfigState = {
  data: {},
  initializedFromInitScript: false,
  publicUrl: undefined,
};

const reducer: Reducer<ConfigState> = (state = initialState, action) => {
  switch (action.type) {
    case ConfigActionTypes.CONFIG_SUCCESS: {
      return {
        ...state,
        data: { ...action.payload.data },
        initializedFromInitScript: action.payload.initializedFromInitScript || false,
        publicUrl: action.payload.publicUrl,
      };
    }
    case ConfigActionTypes.CONFIG_UPDATE_ENDPOINT_PARAMS: {
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload,
        },
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as configReducer };
